import * as React from 'react';

import { StatisticListGroupProps } from './types';
import StatisticWithLabelAndCount from '../StatisticWithLabelAndCount';
import { NON_ALPHANUMERIC_REGEX } from '../types';

export default function StatisticListGroup(props: StatisticListGroupProps) {
    const {
        id,
        itemClass,
        statistics
    } = props;

    return (
        <>
            {statistics.map((stat) => (
                <StatisticWithLabelAndCount
                    className={itemClass || ''}
                    id={id ? `${id}_${stat.title.replace(NON_ALPHANUMERIC_REGEX, '')}` : ''}
                    key={`statListItem_${stat.title}`}
                    statistic={stat}
                />
            ))}
        </>
    );
}